import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RecipiService {
  
  
  url = "https://gestionedb.altervista.org/Acquaperlina/dati.php";
  url1 = "https://www.jerrynoris.it/json_asp/json_db.asp";
  urlProg = "https://tv.zam.it/gadget/gadget_tv.php";
  urlMeteo = "./assets/data/meteo.json";
  data: any;

  constructor(private http:HttpClient) { }

  //selezione programmi
  getRai1(){
    return this.http.get('https://www.rai.it/PalinsestiNeoFE/getJson.do?action=getDirette&canali=1');
    }

  getRai2(){
    return this.http.get('https://www.rai.it/PalinsestiNeoFE/getJson.do?action=getDirette&canali=2');
    }
  getRai3(){
    return this.http.get('https://www.rai.it/PalinsestiNeoFE/getJson.do?action=getDirette&canali=3');     
   }

   getRai4(){
    return this.http.get('https://www.rai.it/PalinsestiNeoFE/getJson.do?action=getDirette&canali=41');
    }
    getRaipremium(){
      return this.http.get('https://www.rai.it/PalinsestiNeoFE/getJson.do?action=getDirette&canali=32');
      }
    getRaiextra(){
      return this.http.get('https://www.rai.it/PalinsestiNeoFE/getJson.do?action=getDirette&canali=31');
      }
      getRainews24(){
        return this.http.get('https://www.rai.it/PalinsestiNeoFE/getJson.do?action=getDirette&canali=25');
        }  
        getRaistoria(){
          return this.http.get('https://www.rai.it/PalinsestiNeoFE/getJson.do?action=getDirette&canali=28');
          }  
          getProg(){
            return this.http.get('https://tv.zam.it/gadget/gadget_tv.php');
            }      
  // progrmed  
  API_KEY = 'lxXBnBT7BkUDTiEkQ3L0fT';        

 

  getDetails(IDprodotto){
    let data: Observable<any> = this.http.get(this.url);
      return data
      .pipe(map((items) => {
        return items.find((item) =>
        (item.IDprodotto == IDprodotto));
      })
      );
    }

    getDetailsJerry(id_immagine){
      let data: Observable<any> = this.http.get(this.url1);
        return data
        .pipe(map((items) => {
          return items.find((item) =>
          (item.id_immagine == id_immagine));
        })
        );
      }

      getDetailsMeteo(id){
        let data: Observable<any> = this.http.get(this.urlMeteo);
          return data
          .pipe(map((items) => {
            return items.find((item) =>
            (item.id == id));
          })
          );
        }
      

}
